import { render, staticRenderFns } from "./CreatedDate.vue?vue&type=template&id=1a34c4f2&"
import script from "./CreatedDate.vue?vue&type=script&lang=ts&"
export * from "./CreatedDate.vue?vue&type=script&lang=ts&"
import style0 from "./CreatedDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports